import { TYPE_SIZES } from '../../utils/globalConst.js';
import InputControl from '../InputControl/InputControl.vue.js';
import vClickOutside from 'v-click-outside';
import ElementItem from '../ElementItem/ElementItem.vue.js';
import getReplaceCaption from '../../utils/getReplaceCaption.js';
import removeClass from '../../utils/removeClass.js';

//
var script = {
  name: 'Autocomplete',
  components: {
    InputControl: InputControl,
    ElementItem: ElementItem
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input'
  },
  inject: {
    formItem: {
      default: ''
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    suggestionsList: {
      type: Array,
      default: function () { return []; }
    },
    currentIdPath: {
      type: String,
      default: 'id'
    },
    currentTitlePath: {
      type: String,
      default: 'title'
    },
    maxHeightSuggestionsList: {
      type: Number,
      default: 200
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    showSuggestions: {
      type: Boolean,
      default: false
    },
    classModsInput: {
      type: String,
      default: ''
    },
    classFocusSuggestion: {
      type: String,
      default: '_focus'
    },
    sizeSuggestion: {
      type: String,
      default: TYPE_SIZES.large.value
    },
    textForEmptyList: {
      type: String,
      default: 'Ничего не найдено'
    },
    isOpeningSuggestionsUp: {
      type: Boolean,
      default: false
    },
    sizeInput: {
      type: String,
      default: TYPE_SIZES.large.value
    }
  },
  data: function (vm) { return ({
    query: vm.value,
    currentIndexElement: -1
  }); },
  watch: {
    value: function value(value$1) {
      this.query = value$1;
    },

    showSuggestions: function showSuggestions(value) {
      if (value) {
        this.$nextTick(this.defineSizes);
      } else {
        this.currentIndexElement = -1;
      }
    },

    suggestionsList: function suggestionsList(list, oldList) {
      if (list.length !== oldList.length) {
        this.$nextTick(this.defineSizes);
        this.currentIndexElement = -1;
      }
    }

  },

  mounted: function mounted() {
    if (this.showSuggestions) {
      this.$nextTick(this.defineSizes);
    }
  },

  methods: {
    handlerInput: function handlerInput(value) {
      this.query = value;
      this.$emit('input', value);
    },

    handlerFocusInput: function handlerFocusInput() {
      this.$emit('focus');
    },

    handlerBlurInput: function handlerBlurInput() {
      this.$emit('blur');
    },

    handlerClearInput: function handlerClearInput() {
      this.$emit('clear');
    },

    handlerHideSuggestions: function handlerHideSuggestions() {
      this.$emit('hide-suggestions');
    },

    handlerClickItem: function handlerClickItem(event, item) {
      this.$emit('selected-item', item);
      this.query = item[this.currentTitlePath];
    },

    handlerClickOutside: function handlerClickOutside(event) {
      this.$emit('click-outside', event);
    },

    handlerDown: function handlerDown() {
      if (this.showSuggestions && !!this.suggestionsList.length) {
        this.moveResults('down');
      }
    },

    handlerUp: function handlerUp() {
      if (this.showSuggestions && !!this.suggestionsList.length) {
        this.moveResults('up');
      }
    },

    handlerEnter: function handlerEnter(event) {
      if (this.showSuggestions && !!this.suggestionsList.length) {
        this.handlerClickItem(event, this.suggestionsList[this.currentIndexElement >= 0 ? this.currentIndexElement : 0]);
      }
    },

    handlerHoverResults: function handlerHoverResults() {
      removeClass(this.$refs.resultItem, this.classFocusSuggestion);
    },

    onFocus: function onFocus() {
      this.$refs.input.focus();
    },

    onBlur: function onBlur() {
      this.$refs.input.blur();
    },

    onClear: function onClear() {
      this.$refs.input.clear();
    },

    getSearchCaption: function getSearchCaption(caption) {
      return getReplaceCaption(caption, this.query);
    },

    defineSizes: function defineSizes() {
      var this$1 = this;

      if (this.$refs.autocomplete && this.$refs.resultBody) {
        var resultEl = this.$refs.resultBody;
        var buttonEl = this.$refs.autocomplete;

        if (!this.formItem) {
          buttonEl = this.$refs.autocomplete.querySelector('.b24-input-control__body');
        }

        var rectsButton = buttonEl.getBoundingClientRect();
        var bottom = window.innerHeight - rectsButton.top - rectsButton.height;

        var position = function (topPosition, direction) {
          if ( direction === void 0 ) direction = 'bottom';

          resultEl.style.top = topPosition + "px";
          resultEl.style.boxShadow = "0 " + (direction !== 'bottom' ? '-' : '') + "2px 4px rgba(0, 0, 0, 0.16)";
          this$1.$emit('opened-select', direction);
        };

        if (bottom < resultEl.clientHeight && this.isOpeningSuggestionsUp) {
          var posTop = -resultEl.clientHeight;

          if (!this.formItem) {
            var inputControlLabel = this.$refs.autocomplete.querySelector('.b24-input-control__label');
            var inputControlAfterDesc = this.$refs.autocomplete.querySelector('.b24-input-control__desc._after');
            posTop += inputControlLabel ? inputControlLabel.clientHeight : 0;
            posTop += inputControlAfterDesc ? inputControlAfterDesc.clientHeight : 0;
          }

          position(posTop, 'top');
        } else {
          position(rectsButton.height);
        }
      }
    },

    moveResults: function moveResults(eventType) {
      if ( eventType === void 0 ) eventType = 'down';

      var index = 0;
      var items = this.$refs.resultItem;

      if (eventType === 'up') {
        index = this.currentIndexElement <= 0 ? items.length - 1 : this.currentIndexElement - 1;
      }

      if (eventType === 'down') {
        index = this.currentIndexElement >= items.length - 1 ? 0 : this.currentIndexElement + 1;
      }

      this.currentIndexElement = index;
      removeClass(items, this.classFocusSuggestion);
      items[index].$el.classList.add(this.classFocusSuggestion);
      var top = 0;
      items.forEach(function (item, indexItem) {
        if (index === 0) {
          top = 0;
        } else if (indexItem < index) {
          top += item.$el.clientHeight;
        }
      });
      this.$refs.resultBody.scrollTop = top;
    }

  }
};

export default script;
